import React, { useState } from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box, Tabs, Tab, Paper, Select, MenuItem, useMediaQuery, useTheme } from '@mui/material';

const teamCategories = [
  {
    id: 'voice-over',
    label: 'الفريق الصوتى',
    members: [
      { name: 'عمرو يسرى', role: 'Voice Over', image: '/images/team/amr-yousry.jpg' },
      { name: 'مي علي', role: 'Voice Over', image: '/images/team/may-ali.jpg' },
      { name: 'وسام ابراهيم', role: 'Voice Over', image: '/images/team/wessam-ibrahim.jpg' },
      { name: 'سارة علي', role: 'Voice Over', image: '/images/team/sara-ali.jpg' },
      { name: 'باسم أمين', role: 'Voice Over', image: '/images/team/bassem-amin.jpg' },
      { name: 'أشرف يحيى', role: 'Voice Over', image: '/images/team/ashraf-yahia.jpg' },
      { name: 'ابراهيم محسن', role: 'Voice Over', image: '/images/team/ibrahim-mohsen.jpg' },
      { name: 'شريف منصور', role: 'Voice Over', image: '/images/team/sherif-mansour.jpg' },
      { name: 'محمد صلاح', role: 'Voice Over', image: '/images/team/mohamed-salah.jpg' },
      { name: 'سلمى درويش', role: 'Voice Over', image: '/images/team/salma-darwish.jpg' },
      { name: 'جمال حداد', role: 'Voice Over', image: '/images/team/gamal-haddad.jpg' },
      { name: 'وفاء شعراوي', role: 'Voice Over', image: '/images/team/wafaa-shaarawy.png' },
      { name: 'مصطفى عادل', role: 'Voice Over', image: '/images/team/mostafa-adel.jpg' },
      { name: 'أحمد طه', role: 'Voice Over', image: '/images/team/ahmed-taha.jpg' },
      { name: 'محمد خميس', role: 'Actor', image: '/images/team/mohamed-khamis.jpg' },
      { name: 'اسراء مصطفى', role: 'Voice Over', image: '/images/team/esraa-mustafa.jpg' },
      { name: 'محمود عيسى', role: 'Voice Over', image: '/images/team/mahmoud-issa.jpg' },
      { name: 'سالي دياب', role: 'Voice Over', image: '/images/team/sally-diab.jpg' },
      { name: 'محمد نادي', role: 'Voice Over', image: '/images/team/mohamed-nady.jpeg' },
      { name: 'آية الشرقاوي', role: 'Voice Over', image: '/images/team/aya-el-sharkawy.jpg' },
      { name: 'هيثم الباشا', role: 'Voice Over', image: '/images/team/haytham-el-basha.jpg' },
      { name: 'كندة عمرو', role: 'Voice Over', image: '/images/team/kenda-amr.jpeg' },
      { name: 'ايمي هيتاري', role: 'Singer', image: '/images/team/amy-hitari.jpg' },
      { name: 'أيمن محمود', role: 'Voice Over', image: '/images/team/ayman-mahmoud.jpg' },
      { name: 'اجلال الأعصر', role: 'Voice Over', image: '/images/team/eglal-el-asr.jpg' },
      { name: 'أحمد فوزي', role: 'Voice Over', image: '/images/team/ahmed-fawzy.jpg' },
      { name: 'ايلينا هونر', role: 'Voice Over', image: '/images/team/elena-honer.jpg' },
      { name: 'أسماء ماهر', role: 'Voice Over', image: '/images/team/asmaa-maher.png' },
      { name: 'محمد طويلة', role: 'Voice Over', image: '/images/team/mohamed-tawila.jpeg' },
      { name: 'السيد عبدالكريم', role: 'Voice Over', image: '/images/team/elsayed-abdelkareem.jpg' },
      { name: 'أحمد عطيه - بسنت المصري', role: 'Voice Over', image: '/images/team/ahmed-ateya-basant.jpg' },
      { name: 'ضياء حمدي', role: 'Voice Over', image: '/images/team/diaa-hamdy.jpg' },
      { name: 'عبدالفتاح الطنطاوي', role: 'Voice Over', image: '/images/team/abdel-fattah-el-tantawy.jpg' },
      { name: 'حاتم لافي', role: 'Voice Over', image: '/images/team/hatem-lafi.jpg' },
      { name: 'لارا عمرو', role: 'Voice Over', image: '/images/team/lara-amr.jpg' },
      { name: 'حمزة البشري', role: 'Voice Over', image: '/images/team/hamza-el-beshry.jpg' },
      { name: 'حسام حمدي', role: 'Voice Over', image: '/images/team/hesham-hamdy.jpg' },
      { name: 'سعيد عز الدين', role: 'Voice Over', image: '/images/team/saeed-azzeldin.jpeg' },
      { name: 'محمد هديب', role: 'Voice Over', image: '/images/team/mohamed-hadeeb.jpeg' },
      { name: 'حلمي جلال', role: 'Voice Over', image: '/images/team/helmy-galal.jpg' },
      { name: 'خالد يسري', role: 'Voice Over', image: '/images/team/khaled-yousry.jpg' },
      { name: 'سالمة الشافعي', role: 'Voice Over', image: '/images/team/salma-el-shafie.jpg' },
      { name: 'ابراهيم خليفة', role: 'Voice Over', image: '/images/team/ibrahim-khalifa.jpeg' },
      { name: 'داليا جلال', role: 'Voice Over', image: '/images/team/dalia-galal.jpg' },
      { name: 'دعاء محمود', role: 'Voice Over', image: '/images/team/doaa-mahmoud.jpg' },
      { name: 'رضوى هاني', role: 'Voice Over', image: '/images/team/radwa-hany.jpg' },
      { name: 'أسما الشال', role: 'Voice Over', image: '/images/team/asmaa-el-shal.jpg' },
      { name: 'أحمد رؤوف', role: 'Voice Over', image: '/images/team/ahmed-raouf.jpg' },
      { name: 'ريم العقاد', role: 'Voice Over', image: '/images/team/reem-el-akkad.jpg' },
      { name: 'هادي تميم', role: 'Voice Over', image: '/images/team/hady-tameem.jpeg' },
      { name: 'مصطفى علي', role: 'Voice Over', image: '/images/team/mostafa-ali.jpg' },
      { name: 'آمال الجندي', role: 'Voice Over', image: '/images/team/amal-el-gendy.jpg' },
      { name: 'محمد محي', role: 'Voice Over', image: '/images/team/mohamed-mohy.jpg'  },
      { name: 'سالي أشرف', role: 'Voice Over', image: '/images/team/sally-ashraf.jpg'  },
      { name: 'ريما الحبيبي', role: 'Voice Over', image: '/images/team/rema.jpg'  },
      { name: 'اسلام كشك', role: 'Voice Over', image: '/images/team/islam.jpg'  },
      { name: 'شيماء فتحي', role: 'Voice Over', image: '/images/team/shimaa.jpg'  },
      { name: 'صفاء صفوت', role: 'Voice Over', image: '/images/team/safaa.jpg'  },
      { name: 'كريم النجار', role: 'Voice Over', image: '/images/team/nagaar.jpg'  },
      { name: 'عبدالرحمن الهلالي', role: 'Voice Over', image: '/images/team/helaly.jpg'  },
      { name: 'عزيزة التومي', role: 'Voice Over', image: '/images/team/aziza.jpg'  },
      { name: 'يوسف الطحان', role: 'Voice Over', image: '/images/team/youssef-el-tahan.jpg' },
      { name: 'علي السرسي', role: 'Voice Over', image: '/images/team/ali-el-sersy.jpg' },
      { name: 'فاطمة فرج', role: 'Voice Over', image: '/images/team/fatma-farag.jpg' },
      { name: 'محمد غانم', role: 'Voice Over', image: '/images/team/mohamed-ghanem.jpeg' },
      { name: 'محمد عامر', role: 'Voice Over', image: '/images/team/mohamed-amer.jpg' },
      { name: 'محمد فوزي', role: 'Voice Over', image: '/images/team/mohamed-fawzy.jpg' },
      { name: 'محمد هنداوي', role: 'Voice Over', image: '/images/team/mohamed-hindawy.jpg' },
      { name: 'محمد وجيه', role: 'Voice Over', image: '/images/team/mohamed-wageeh.jpg' },
      { name: 'هيثم العماري', role: 'Voice Over', image: '/images/team/haytham-el-omary.jpg' },
      { name: 'محمود هاني', role: 'Voice Over', image: '/images/team/mahmoud-hany.jpg' },
      { name: 'مروان الرفاعي', role: 'Voice Over', image: '/images/team/marwan-el-refaey.jpg' },
      { name: 'منة هاني', role: 'Voice Over', image: '/images/team/menna-hany.jpg' },
      { name: 'ياسمين صادق', role: 'Voice Over', image: '/images/team/yasmin-sadek.jpg' },
      { name: 'معاذ صلاح', role: 'Voice Over', image: '/images/team/moaz-salah.jpeg' },
      { name: 'مي محمود', role: 'Voice Over', image: '/images/team/may-mahmoud.jpg' },
      { name: 'أحمد طه', role: 'Voice Over', image: '/images/team/ahmed-taha2.jpg' },
      { name: 'طالب سليمان', role: 'Voice Over', image: '/images/team/taleb-suleiman.jpg' },
      { name: 'محمد صفوت', role: 'Voice Over', image: '/images/team/mohamed-safwat.jpg' },
      { name: 'تامر رفعت', role: 'Voice Over', image: '/images/team/tamer-refaat.jpg' },
      { name: 'مروة محرم', role: 'Voice Over', image: '/images/team/marwa-moharam.jpg' },
      { name: 'أحمد مجدي', role: 'Voice Over', image: '/images/team/ahmed-magdy.jpeg' },
      { name: 'ميرنا عباس', role: 'Voice Over', image: '/images/team/mirna-abbas.jpg' },
      { name: 'محمد أحمد', role: 'Voice Over', image: '/images/team/mohamed-ahmed.jpg' },
      { name: 'محمد الميتكناني', role: 'Voice Over', image: '/images/team/mohamed-el-metkenany.jpg' },
      { name: 'محمد م. محي', role: 'Voice Over', image: '/images/team/mohamed-mohie.jpg' },
      { name: 'آيه أحمد', role: 'Voice Over', image: '/images/team/aya-ahmed.jpg' },
      { name: 'جنا الشناوي', role: 'Voice Over', image: '/images/team/gina-el-shennawy.jpg' },
      { name: 'فاطمة قاسم', role: 'Voice Over', image: '/images/team/fatma-kassem.jpg' },
      { name: 'سهاد الغنيمي', role: 'Voice Over', image: '/images/team/suhad-el-ghanemy.jpg' },
      { name: 'معاذ بكري', role: 'Voice Over', image: '/images/team/moaz-bakry.jpeg' },
      { name: 'شيماء عبد الهادى', role: 'Voice Over', image: '/images/team/shaimaa-abdel-hady.jpeg' },
      { name: 'سعيد عامر', role: 'Voice Over', image: '/images/team/saeed-amer.jpg' },
      { name: 'أحمد صميدة', role: 'Voice Over', image: '/images/team/ahmed-samida.jpeg' },
      { name: 'عبدالله كرم', role: 'Voice Over', image: '/images/team/abdallah-karam.jpeg' },
    ]
  },
  {
    id: 'language-editing',
    label: 'فريق الضبط اللغوى',
    members: [
      { name: 'نشوى خالد', role: 'الضبط اللغوى', image: '/images/team/nashwa.jpg' },
      { name: 'أروى محمود', role: 'الضبط اللغوى', image: '/images/team/arwa-mahmoud.jpg' },
      { name: 'فاطمة الزهراء', role: 'الضبط اللغوى', image: '/images/team/fatma-el-zahraa.jpg' },
      { name: 'كلاوديا داوود', role: 'الضبط اللغوى', image: '/images/team/claudia-dawoud.jpg' },
      { name: 'سنية اسماعيل', role: 'الضبط اللغوى', image: '/images/team/sania-ismail.jpg' },
      { name: 'يوسف ماضي', role: 'الضبط اللغوى', image: '/images/team/youssef-mady.jpg' },
      { name: 'أحمد عتمان', role: 'الضبط اللغوى', image: '/images/team/ahmed-otman.jpg' },
    ]
  },
  {
    id: 'translation',
    label: 'فريق الترجمة',
    members: [
      { name: 'الشيماء', role: 'ترجمة', image: '/images/team/el-shaimaa.jpg' },
      { name: 'هبه محرم', role: 'ترجمة', image: '/images/team/heba-moharam.jpg' },
      { name: 'سارة كامل', role: 'ترجمة', image: '/images/team/sara-kamel.jpg' },
      { name: 'ريم يوسف', role: 'ترجمة', image: '/images/team/reem-youssef.jpg' },
      { name: 'وفاء شعراوي', role: 'ترجمة', image: '/images/team/wafaa-shaarawy.png' },
      { name: 'شريف أبو معاذ', role: 'ترجمة', image: '/images/team/sherif-abu-moaz.jpg' },
    ]
  },
  {
    id: 'audio-engineering',
    label: 'فريق مهندسي الصوت',
    members: [
      { name: 'عمرو يسرى', role: 'هندسة اذاعية', image: '/images/team/amr-yousry.jpg' },
      { name: 'سمر علاء الدين', role: 'إعداد إذاعي', image: '/images/team/samar-alaa-eldin.jpg' },
      { name: 'سامح القاضي', role: 'إعداد إذاعي', image: '/images/team/sameh-el-kady.jpg' },
      { name: 'محمد يسري', role: 'مونتاج', image: '/images/team/mohamed-yousry.jpg' },
      { name: 'محمد صدقة', role: 'هندسة اذاعية', image: '/images/team/mohamed-sedka.jpg' },
      { name: 'أسماء راشد', role: 'هندسة اذاعية', image: '/images/team/asmaa-rashed.jpg' },
      { name: 'أحمد مجدي', role: 'هندسة اذاعية', image: '/images/team/ahmed-magdy.jpg' },
      { name: 'ابراهيم ابو سليمة', role: 'هندسة اذاعية', image: '/images/team/ibrahim-abu-sleema.jpg' },
      { name: 'مروان خميس', role: 'هندسة اذاعية', image: '/images/team/marwan-khamis.jpg' },
    ]
  },
  {
    id: 'design',
    label: 'فريق التصميم',
    members: [
      { name: 'سامح القاضي', role: 'GRAPHIC DESIGN & VIDEO EDITING', image: '/images/team/sameh-el-kady.jpg' },
      { name: 'سمر علاء الدين', role: 'Graphic design', image: '/images/team/samar-alaa-eldin.jpg' },
      { name: 'مايا البلتاجي', role: 'Graphic design', image: '/images/team/maya-el-beltagy.jpg' },
      { name: 'شادي الشيمي', role: 'موسيقار', image: '/images/team/shady-el-sheemy.jpg' },
      { name: 'مروان خميس', role: 'Graphic design & video editing', image: '/images/team/marwan-khamis.jpg' },
      { name: 'كريم البنا', role: 'Graphic design', image: '/images/team/karim-el-banna.jpg' },
      { name: 'اسلام عمر', role: 'Graphic design', image: '/images/team/islam-omar.jpg' },
      { name: 'ميرنا خالد', role: 'Graphic design', image: '/images/team/mirna-khaled.jpg' },
    ]
  },
  {
    id: 'technical',
    label: 'الفريق التقنى',
    members: [
      { name: 'ابراهيم قريقع', role: 'Full stack developer', image: '/images/team/ibrahim-qariqa.jpg' },
      { name: 'سمر علاء الدين', role: 'Senior UI-UX Designer', image: '/images/team/samar-alaa-eldin.jpg' },
      { name: 'Mujahed Altahleh', role: 'Senior Infrastructure Engineer', image: '/images/team/mujahed-altahleh.jpg' },
      { name: 'أحمد جابر', role: 'Android Developer', image: '/images/team/ahmed-gaber.jpg' },
      { name: 'سارة سامى', role: 'android developer', image: '/images/team/sara-samy.jpg' },
      { name: 'عمرو حمدلله', role: 'MERN developer', image: '/images/team/amr-hamdallah.jpg' },
    ]
  }
];

const TeamMembers = () => {
  const [selectedCategory, setSelectedCategory] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(typeof newValue === 'number' ? newValue : parseInt(event.target.value));
  };

  const renderNavigation = () => {
    if (isMobile) {
      return (
        <Select
          value={selectedCategory}
          onChange={handleCategoryChange}
          fullWidth
          sx={{
            backgroundColor: '#1f1f1f',
            color: 'white',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.23)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.23)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
            '.MuiSvgIcon-root': {
              color: 'white',
            }
          }}
        >
          {teamCategories.map((category, index) => (
            <MenuItem 
              key={category.id} 
              value={index}
              sx={{
                color: '#141414',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                }
              }}
            >
              {category.label}
            </MenuItem>
          ))}
        </Select>
      );
    }

    return (
      <Paper 
        sx={{ 
          width: '100%', 
          mb: 4, 
          backgroundColor: '#1f1f1f',
          overflowX: 'hidden',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Tabs
          value={selectedCategory}
          onChange={handleCategoryChange}
          aria-label="team categories"
          sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            '& .MuiTab-root': {
              color: '#9ca3af',
              minWidth: 'auto',
              padding: '12px 24px',
              '&.Mui-selected': {
                color: 'white'
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: 'white'
            }
          }}
        >
          {teamCategories.map((category) => (
            <Tab key={category.id} label={category.label} />
          ))}
        </Tabs>
      </Paper>
    );
  };

  return (
    <Box sx={{ 
      pt: 8, 
      pb: 6, 
      backgroundColor: '#141414',
      width: '100%',
      overflowX: 'hidden'
    }}>
      <Container maxWidth="lg" sx={{ overflowX: 'hidden' }}>
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="white"
          gutterBottom
          sx={{ mt: 8, mb: 4 }}
        >
          فريق عمل أوديوهات 
        </Typography>

        <Box sx={{ mb: 4 }}>
          {renderNavigation()}
        </Box>

        <Grid container spacing={4}>
          {teamCategories[selectedCategory].members.map((member, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} lg={2}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  backgroundColor: '#141414',
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
                  }
                }}
              >
                <Box sx={{ 
                  position: 'relative',
                  paddingTop: '100%', // 1:1 Aspect ratio
                  width: '100%',
                  backgroundColor: '#1f1f1f'
                }}>
                  <CardMedia
                    component="img"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center 15%', // Adjust to favor the face area
                      borderTopLeftRadius: '16px',
                      borderTopRightRadius: '16px'
                    }}
                    image={member.image}
                    alt={member.name}
                    onError={(e) => {
                      e.target.src = '/images/team/placeholder.jpg';
                    }}
                  />
                </Box>
                <CardContent sx={{ 
                  flexGrow: 1,
                  backgroundColor: '#141414',
                  color: 'white',
                  '&:last-child': {
                    paddingBottom: '16px'
                  }
                }}>
                  <Typography 
                    gutterBottom 
                    variant="h6" 
                    component="h2" 
                    align="center"
                    sx={{
                      color: 'white',
                      fontWeight: 'bold',
                      marginBottom: '8px'
                    }}
                  >
                    {member.name}
                  </Typography>
                  <Typography 
                    variant="subtitle1" 
                    align="center"
                    sx={{
                      color: '#9ca3af',
                      fontSize: '0.875rem'
                    }}
                  >
                    {member.role}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TeamMembers; 